<matchmaking-key-benefits data-cy="key-benefits"></matchmaking-key-benefits>
@if (videos()?.length) {
  <matchmaking-videos [videos]="videos() ?? []" />
}
<sirius-spacer></sirius-spacer>
@if (form()) {
  <matchmaking-formular></matchmaking-formular>
}
<div class="buttons-container">
  <matchmaking-form-back-button
    (click)="handleBack()"
    [text]="translations()!.button.back"
    data-cy="back-button">
  </matchmaking-form-back-button>
</div>

<div class="grey-background-container">
  @if (caseStories()?.length) {
    <matchmaking-case-stories
      [caseStories]="caseStories() ?? []"
      [application]="application()" />
  }
</div>
